import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { AuthService } from '../../../services/common/auth.service';
import { AlertService } from '../../../services/common/alert.service';
import { AppointmentRequestService } from '../../../services/appointment_requests/appointment-request.service';
import { AppointmentRequestResultService } from '../../../services/appointment_requests/appointment-request-result.service';

@Component({
  selector: 'app-appointment-request-show',
  templateUrl: './appointment-request-show.component.html',
  styleUrls: ['./appointment-request-show.component.css'],
  providers: [AppointmentRequestResultService],
})
export class AppointmentRequestShowComponent implements OnInit {
  appointment_request: any;
  editingOngoingNote: boolean = false;
  appointment_request_result_form_options: any;
  showAppointmentRequestResultForm: boolean = false;

  attorney: boolean = false;
  super_user: boolean = false;
  routerEventsSubscription: Subscription;
  tech: boolean = false;

  constructor(private authService: AuthService, private alertService: AlertService, private appointmentRequestService: AppointmentRequestService, private appointmentRequestResultService: AppointmentRequestResultService, private route: ActivatedRoute, private router: Router) {
    this.routerEventsSubscription = this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event) => {
      this.loadPage();
    });
    this.authService.fetchUserGroups().then((groups) => {
      for (var i in groups) {
        var group = String(groups[i]).toLowerCase();
        if (group == 'attorney') this.attorney = true;
        else if (group == 'tech') this.tech = true;
      }
    });
  }

  ngOnInit() {
    this.appointmentRequestService.getAppointmentRequest(this.route.snapshot.params['id']).then((appointment_request) => {
      this.appointment_request = appointment_request;
      this.appointmentRequestService.getAppointmentRequestResultFormOptions().then((response_json) => {
        this.appointment_request_result_form_options = response_json;
      });
    });
  }

  checkOutAppointmentRequest() {
    this.appointmentRequestService.updateAppointmentRequest(this.appointment_request.id, { check_out: true }).then((response_json) => {
      this.appointment_request.editing_allowed_while_checked_out = true;
      this.appointment_request.checked_out = true;
      this.appointment_request.checked_out_by_name = response_json.checked_out_by_name;
      this.appointment_request.checked_out_on = response_json.checked_out_on;
    });
  }

  loadPage() {
    this.authService.fetchUserGroups().then((groups) => {
      for (var i in groups) {
        var group = String(groups[i]).toLowerCase();
        if (group == 'attorney') this.attorney = true;
        else if (group == 'tech') this.tech = true;
      }
      this.appointmentRequestService.getAppointmentRequest(this.route.snapshot.params['id']).then((appointment_request) => {
        this.appointment_request = appointment_request;
        this.appointmentRequestService.getAppointmentRequestResultFormOptions().then((response_json) => {
          this.appointment_request_result_form_options = response_json;
        });
      });
    });
  }

  releaseCheckOut() {
    this.appointmentRequestService.updateAppointmentRequest(this.appointment_request.id, { release_checkout: true }).then((response_json) => {
      this.appointment_request.editing_allowed_while_checked_out = false;
      this.appointment_request.checked_out = false;
      this.appointment_request.checked_out_by_name = null;
      this.appointment_request.checked_out_on = null;
    });
  }

  cancelAppointmentRequest() {
    this.appointmentRequestService
      .cancelAppointmentRequest(this.appointment_request.id)
      .then((response_json) => {
        if (response_json && response_json.text) {
          this.appointment_request.editing_allowed_while_checked_out = false;
          this.appointment_request.checked_out = false;
          this.appointment_request.checked_out_by_name = null;
          this.appointment_request.checked_out_on = null;
          this.appointment_request.cancelled = true;
        } else this.alertService.alert_status_danger('Error cancelling request');
      })
      .catch(() => {
        this.alertService.alert_status_danger('Error cancelling request');
      });
  }

  reinstateAppointmentRequest() {
    this.appointmentRequestService
      .updateAppointmentRequest(this.appointment_request.id, {
        reinstate: true,
      })
      .then((response_json) => {
        if (response_json && response_json.text) this.appointment_request.cancelled = false;
        else this.alertService.alert_status_danger('Error reinstating request');
      })
      .catch(() => {
        this.alertService.alert_status_danger('Error reinstating request');
      });
  }

  saveNote() {
    this.appointmentRequestService.updateAppointmentRequest(this.appointment_request.id, { notes: this.appointment_request.notes }).then((response_json) => {
      if (response_json.text) {
        this.appointment_request.ongoing_notes = this.appointment_request.notes;
        this.editingOngoingNote = false;
      }
    });
  }

  onAppointmentRequestResultSave(returnMessage: string, appointment_request_result: any = null) {
    if (returnMessage == 'FormCancelled') {
      if (appointment_request_result) appointment_request_result.editing = false;
      else this.showAppointmentRequestResultForm = false;
      return;
    }
    this.appointmentRequestService.getAppointmentRequest(this.appointment_request.id).then((response_json) => {
      this.appointment_request = response_json;
    });
    if (appointment_request_result) appointment_request_result.editing = false;
    else this.showAppointmentRequestResultForm = false;
  }

  attemptedContactWith(appointment_request_result: any) {
    if (!appointment_request_result.attendee_name) return '<span class="text-danger">No Attendee specified for contact attempt</span>';
    else
      switch (appointment_request_result.result) {
        case 'Send Email':
          return `${appointment_request_result.attendee_name} by an email at outgoing job <a href="/outgoing_jobs/${appointment_request_result.outgoing_job_id}">#${appointment_request_result.outgoing_job_id}</a>`;
        case 'Send Letter':
          return `${appointment_request_result.attendee_name} by a letter at outgoing job <a href="/outgoing_jobs/${appointment_request_result.outgoing_job_id}">#${appointment_request_result.outgoing_job_id}</a>`;
        case 'Message From Client':
          return `${appointment_request_result.attendee_name} sent a message to the firm`;
        default:
          return `${appointment_request_result.attendee_name} at ${appointment_request_result.phone_number}`;
      }
  }

  resultNotes(appointment_request_result: any) {
    if (appointment_request_result.result == 'Schedule') {
      return `
				<p>
					<strong>Event Details</strong> - <a href='/events/${appointment_request_result.event.id}/edit'>View Event</a><br />
					${appointment_request_result.event.start} - ${appointment_request_result.event.end}
					<table>
						<tbody>
							<tr>
								<td><strong>Duration:&nbsp;</strong></td>
								<td>${appointment_request_result.event.duration}</td>
							</tr>
							<tr>
								<td><strong>Event Type:&nbsp;</strong></td>
								<td>${appointment_request_result.event.event_type_name}</td>
							</tr>
							<tr>
								${
                  appointment_request_result.event.event_type_name.toLowerCase() == 'phone conference'
                    ? appointment_request_result.event.initiates_phone_call.toLowerCase() == 'you' || String(appointment_request_result.event.initiates_phone_call) == 'true'
                      ? "<td colspan='2'>" + 'We initiate phone call' + '</td>'
                      : "<td colspan='2'>" + 'Contact initiates phone call' + '</td>'
                    : ''
                }
							</tr>
							<tr>
								<td colspan='2'>${appointment_request_result.event.is_active ? '<span class="text-success">Event is active</span>' : '<span class="text-danger">Event is inactive</span>'}</td>
							</tr>
						</tbody>
					</table>
				</p>
			`;
    } else {
      return `<strong>${appointment_request_result.result}</strong><br />${appointment_request_result.notes}`;
    }
  }

  emailResult(appointment_request_result: any) {
    appointment_request_result.emailing_to_attorney = true;
    this.appointmentRequestResultService
      .getAppointmentRequestResult(appointment_request_result.id, { email_result: true })
      .then((response_json) => {
        appointment_request_result.emailing_to_attorney = false;
        this.alertService.alert_status_info(response_json.text);
      })
      .catch(() => {
        appointment_request_result.emailing_to_attorney = false;
        this.alertService.alert_status_danger('Error sending email');
      });
  }
}
